import React, { useEffect, useState, ReactNode, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';

import './scss/staff-size.scss';
import SubTitle from '../component/sub-title';
import Color from '@/tool/color';

import Tab from '../component/tab';
import TimeTab from '../component/time-tab';
import moStaff, { changeStaffShow, changeTab } from './store/staff-size';
import StaffChart from './component/staff-chart';
import CommonTable from '../component/common-table';
import Empty from '@/component/empty';
import URI from 'urijs';
import MainTitle from '../component/main-title';
import Sub from '../component/sub';
import moMenu from '@/page/effect/store/menu';


interface IProps { }
interface IState { }

const StaffSize = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { staffList } = moStaff;
  const uri = new URI(window.location.href);
  const path: any = uri.query(true);
  const result: any = decodeURIComponent(path.check);
  const data = JSON.parse(result);

  const emenOver: any = {
    元均营业收入: 'yuan_revenue_overview',
    元均净利润: 'yuan_profit_overview',
  };

  const emen: any = {
    元均营业收入: 'yuan_revenue_data',
    元均净利润: 'yuan_profit_data',
  };
  const showList = (val: string) => {
    const active = emenOver[val];
    let list: any = [];
    if (!isEmpty(staffList)) {
      if (staffList[active].filter((res: any) => res.length > 0).length > 0) {
        list = staffList[active];
      }
    }
    return list;
  };

  const showChartList = (val: string) => {
    const active = emen[val];
    const xData: any = [];
    const list: any = [];
    if (!isEmpty(staffList)) {
      staffList[active].forEach((ele: any) => {
        xData.push(ele.year);
        list.push(ele.value);
      });
    }
    return { xData, list };
  };

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect05" className="staff-size-warp-pdf human-common-pdf">
      <MainTitle
        title='员工规模与元均效能'
        subtitle={moMenu.industryName}
        bgcolor={Color.primaryColor(0.1)}
        color={Color.primary} />
      {data.tabList?.e1 && <section>
        <Sub title='元均营业收入' />
        <section className="chart-demo">
          {!isEmpty(showChartList('元均营业收入')) ?
            <section className="chart">
              <StaffChart activeTab='元均营业收入' />
            </section> : <Empty />}
        </section>
        {!isEmpty(showList('元均营业收入')) && <section className="chart-detail staff-detail">
          {
            showList('元均营业收入')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? `${round(ele.value * 100, 1)}%` : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

      {data.tabList?.e2 && <section>
        <Sub title='元均净利润' />
        <section className="chart-demo">
          {!isEmpty(showChartList('元均净利润')) ?
            <section className="chart">
              <StaffChart activeTab='元均净利润' />
            </section> : <Empty />}
        </section>
        {!isEmpty(showList('元均净利润')) && <section className="chart-detail staff-detail">
          {
            showList('元均净利润')?.map((res: any, r: any) => {
              return <section className='item' key={`${r}`}>
                <b />
                <p >
                  {res.map((ele: any, e: any) => {
                    return <span className={ele.mark} key={`${e}l`}>
                      {isNumber(ele.value) ? `${round(ele.value * 100, 1)}%` : ele.value}
                    </span>;
                  })}
                </p>
              </section>;
            })}
        </section>}
      </section>}

    </section>
  );
};

export default observer(StaffSize);
